<template>
  <div v-if="visibleModal" class="send-modal-notifications">
    <div class="send-modal-notifications--wrapper">
      <div class="send-modal-notifications__header">
        <div class="send-modal-notifications__header__title" v-html="title" />
      </div>
      <div class="send-modal-notifications__content">
        <div
          class="send-modal-notifications__content__description"
          v-html="description()"
        />
      </div>
      <div class="send-modal-notifications__footer">
        <div class="send-modal-notifications__footer__actions">
          <custom-button
            label="Sair"
            customClass="custom-secondary medium"
            @btn-click="handleCloseModal"
          />
          <custom-button
            label="Enviar"
            @btn-click="handleSendNotifications(payload)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      visibleModal: ({
        notifications: {
          sendNotification: { visibleConfirmationModal }
        }
      }) => visibleConfirmationModal,
      payload: ({
        notifications: {
          sendNotification: { payload }
        }
      }) => payload
    })
  },
  data() {
    return {
      title: 'Enviar notificação',
      description: () =>
        this.payload.sendToAllUsers
          ? 'Deseja confirmar o envio desta notificação? <br/>  *Sua notificação será enviada para todos os usuários'
          : 'Deseja confirmar o envio desta notificação? '
    }
  },
  components: {
    'custom-button': () =>
      import('@/common/components/design-system/button/CustomButton.vue')
  },
  methods: {
    ...mapActions('notifications', ['sendNotifications']),
    handleCloseModal() {
      this.$store.commit('notifications/UPDATE_SEND_NOTIFICATION', {
        visibleConfirmationModal: false,
        payload: undefined
      })
    },
    async handleSendNotifications() {
      this.$store.commit('HANDLE_PROGRESS_LOADING', true)
      try {
        await this.sendNotifications(this.payload)
      } finally {
        this.$store.commit('HANDLE_PROGRESS_LOADING', false)
      }
    }
  }
}
</script>
<style lang="scss">
.send-modal-notifications {
  background: rgba(53, 56, 64, 0.8);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 15;
  position: fixed;
  justify-content: center;

  &--wrapper {
    box-shadow: $shadow-10;
    background: $base-white;
    min-width: 399px;
    padding: 32px 24px 24px;
    position: absolute;
    border-radius: 8px;
  }

  &__header {
    &__title {
      font-size: 1.5rem;
      text-align: center;
      font-weight: 700;
      line-height: 2rem;
    }
  }

  &__content {
    padding: 16px 0 24px;
    text-align: center;
    &__description {
      font-size: 0.875rem;
      line-height: 1.5rem;
      color: $grayscale-lighten1;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      margin: 0 0.5rem;
    }
  }
}
/* Positions Modal Onboarding */
.centers-modals {
  display: flex;
}
.all-modals {
  display: initial;
}

.margin-wrapper {
  margin-left: 4.5rem;
}
</style>
